// PR-B (GĐ2 audit) — Anonymous auth storm guard.
// localStorage hint — KHÔNG phải nguồn xác thực. Chỉ quyết định có gọi
// GET /auth/me lúc bootstrap hay không; cookie httpOnly vẫn là nguồn thật.
// Guest không có hint → 0 request auth mỗi page-load.
//
// v17.perf.track1 (02-2026) — GỠ migration probe. HAR production cho thấy
// mỗi browser mới vẫn bắn 1 `GET /auth/me` 401 trước LCP. Migration cho phiên
// cookie tồn tại trước PR-B đã đủ thời gian (deploy >6 tháng). Anonymous phải
// zero-auth. Nếu ai lỡ mất hint mà cookie còn sống, hint sẽ tự set lại ở lần
// đăng nhập tiếp theo hoặc khi thao tác yêu cầu auth.
const HINT_KEY = "pl.auth.hint";

export function hasAuthHint() {
  try {
    return window.localStorage.getItem(HINT_KEY) === "1";
  } catch {
    // localStorage bị chặn → fail-open: vẫn probe /auth/me như trước PR-B.
    return true;
  }
}

export function setAuthHint() {
  try {
    window.localStorage.setItem(HINT_KEY, "1");
  } catch { /* noop */ }
}

export function clearAuthHint() {
  try {
    window.localStorage.removeItem(HINT_KEY);
  } catch { /* noop */ }
}

// Anonymous → skip hẳn (0 request). Có hint → probe.
export function shouldBootstrapAuth() {
  return hasAuthHint();
}
